<template>
    <div class="row">
        <div class="column">
            <div class="noBox"></div>
            <h1>{{$t('noAccess.title')}}</h1>
            <p>{{$t('noAccess.pleaseContactAdmin')}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return { }
        }
    }
</script>

<style scoped>
    .column {
        flex-grow: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: 100px;
        padding-top:100px;
    }
    h1, p {
        padding: 12px 0px;
    }
    button {
        margin: 12px 0px;
    }
</style>